<div class="input-date">
  <form class="g-3" [formGroup]="form">
    <div class="input-date--day">
      <input class="form-control"
             [ngClass]="{'input-date--error': invalidDate}"
             formControlName="day"
             maxlength="2"
             placeholder="DD"
             type="tel"
             id="day"
             name="day"
             min="1"
             max="31" />
    </div>
    <div class="input-date--month">
      <input class="form-control"
             [ngClass]="{'input-date--error': invalidDate}"
             formControlName="month"
             maxlength="2"
             placeholder="MM"
             type="tel"
             id="month"
             #monthElement
             name="month"
             min="1"
             max="12" />
    </div>
    <div class="input-date--year">
      <input class="form-control"
             [ngClass]="{'input-date--error': invalidDate}"
             formControlName="year"
             maxlength="4"
             placeholder="YYYY"
             type="tel"
             id="year"
             name="year"
             #yearElement
             min="1900"
             max="2100" />
    </div>
  </form>

  <div class="alert-container" *ngIf="invalidDate">
    <div class="alert alert-danger" yp-e2e-id="invalid-date-error">
      {{INVALID_DATE}}
    </div>
  </div>
</div>

